import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import { DropdownControl } from '../control/dropdown-control';
import { Select, Tooltip } from '@h3/antd-vue';
let dropdownMulti = class dropdownMulti extends DropdownControl {
    // testVal:any
    onChange(val) {
        this.hasSelectBatchImport = false;
        if (val && val.length > 0) {
            if (Array.isArray(val)) {
                const lastVal = val.pop();
                if (lastVal && lastVal.trim().length) {
                    this.setValue([lastVal.trim()]);
                }
                else {
                    this.setValue([]);
                }
            }
            else {
                this.setValue(val);
            }
        }
        else {
            this.ctrl.value = null;
        }
        console.log(this.val);
        if (Array.isArray(val)) {
            this.val = [val.pop()];
        }
        else {
            this.val = val;
        }
        if (!this.multiple) {
            return;
        }
        super.resetDisableds();
        // 如果选中了这个 则收起下拉选项
        const ele = this.$refs.inputDropdown;
        if (ele) {
            ele.blur();
        }
    }
    getOPt() {
        super.getOptions();
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
    destroyed() {
        super.destroyed();
    }
};
dropdownMulti = tslib_1.__decorate([
    Component({
        name: 'dropdownMulti',
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], dropdownMulti);
export default dropdownMulti;
